import { __rest, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { Button } from '../button/Button.js';
import styles from './IconButton.module.scss.js';

var IconButton = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, style = _a.style, _c = _a.size, size = _c === void 0 ? 'm' : _c, buttonProps = __rest(_a, ["className", "style", "size"]);
    return (jsx(Button, __assign({ className: clsx(styles.iconButton, className, (_b = {},
            _b[styles.iconButtonSuperExtraSmall] = size === 'xxs',
            _b[styles.iconButtonExtraSmall] = size === 'xs',
            _b[styles.iconButtonSmall] = size === 's',
            _b[styles.iconButtonMedium] = size === 'm',
            _b[styles.iconButtonLarge] = size === 'l',
            _b)), size: "s", style: style, ref: ref }, buttonProps)));
});

export { IconButton };
